import type { RouteConfig } from 'vue-router'

type ActiveText<T extends string = string> = `a:${T}`
// type Breadcrumb = { text: string; active?: boolean }

const isActiveText = (value: string): value is ActiveText => value.startsWith('a:')

type BreadcrumbConstructor = <A extends Array<ActiveText | string>>(
    ...b: A
) => {
    [I in keyof A]: A[I] extends ActiveText<infer V> ? { text: V; active: true } : { text: A[I] }
}

// @ts-expect-error No problem
export const buildBreadcrumb: BreadcrumbConstructor = (...breads) => {
    return breads.map((text, idx) => {
        const active = isActiveText(text)
        const breadText = active ? text.split(':')[1] : text
        return {
            text: breadText as (typeof breadText)[typeof idx] extends ActiveText<infer V>
                ? V
                : (typeof breadText)[typeof idx],
            active: active || undefined,
        }
    })
}

/**
 *
 * @param prefix String del prefijo
 * @returns un constructor de strings con el prefijo dado
 */
export const createPrefixer: <P extends string>(prefix: P) => <N extends string>(name: N) => `${P}${N}` =
    prefix => name =>
        `${prefix}${name}` as const

export const defineRoutes: <Rt extends RouteConfig>(routes: Rt[]) => Rt[] = routes => routes
